import { render, staticRenderFns } from "./newWindow.vue?vue&type=template&id=6acc4b93&scoped=true&"
import script from "./newWindow.vue?vue&type=script&lang=js&"
export * from "./newWindow.vue?vue&type=script&lang=js&"
import style0 from "./newWindow.vue?vue&type=style&index=0&id=6acc4b93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acc4b93",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6acc4b93')) {
      api.createRecord('6acc4b93', component.options)
    } else {
      api.reload('6acc4b93', component.options)
    }
    module.hot.accept("./newWindow.vue?vue&type=template&id=6acc4b93&scoped=true&", function () {
      api.rerender('6acc4b93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Call/newWindow.vue"
export default component.exports